import React from 'react';

import {Route, Switch, SwitchProps} from 'react-router';
import {Redirect} from 'react-router-dom';

interface Props extends SwitchProps {
    rootPath: string;
}

export const RouterSwitch = ({rootPath, location, children}: Props) => (
    <Switch location={location}>
        {children}

        <Route path={`${rootPath}/*`}>
            <Redirect to={`${rootPath}`} />
        </Route>
    </Switch>
);
